import { Flame } from 'lucide-react';

/**
 * Count consecutive wins on the newest N settled binary trades.
 * Walks from newest → oldest, stops on first loss. Active / cancelled /
 * refunded trades are skipped without breaking the streak.
 *
 * @param {Array} transactions - Recent transactions from /api/dashboard/recent-transactions.
 *   The dashboard endpoint returns items sorted newest→oldest, but this function
 *   defensively re-sorts by timestamp DESC to survive future refactors.
 */
export const computeWinStreak = (transactions = []) => {
  const sorted = [...transactions].sort((a, b) => {
    const ta = a?.timestamp ? Date.parse(a.timestamp) : 0;
    const tb = b?.timestamp ? Date.parse(b.timestamp) : 0;
    return tb - ta;
  });
  let streak = 0;
  for (const t of sorted) {
    if (t.type !== 'binary_trade') continue;
    if (t.status === 'won') streak += 1;
    else if (t.status === 'lost') break;
    // active / cancelled / refunded => skip without breaking
  }
  return streak;
};

const StreakBadge = ({ streak = 0, className = '' }) => {
  if (streak < 2) return null;
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] sm:text-xs font-bold uppercase tracking-wide whitespace-nowrap bg-gradient-to-r from-orange-500 to-rose-500 text-white shadow-[0_0_12px_rgba(251,146,60,0.35)] ${className}`}
      aria-label={`Win streak: ${streak} in a row`}
      data-testid="streak-badge"
    >
      <Flame className="h-3 w-3" />
      {streak} in a row
    </span>
  );
};

export default StreakBadge;
